import { useDispatch } from 'react-redux';
import { Axios, useState, useNavigate, toast, FaEyeSlash, useEffect } from '../../../common/common';
import Validation from '../../../validation/Authentication/Validation.js';
import { useErrorContext } from '../../../context/ErrorContext.js';
import { StartLoading, StopLoading } from '../../../Utils/loadingUtils.js';
import Navigations from '../../../common/useNavigation.js';
import axiosJWT from '../../../secureAPI/axiosJWT.js';
import useGetUserData from '../../../secureAPI/GetUserData';

const MidPersonalDetails = (usertype) => {
  const navigate = useNavigate();
  const { users } = useGetUserData();
  const [isLoading, setisLoading] = useState(false);

  const { validatePersonalDetailsForm } = Validation;
  const { navigateMain, navigateSellerProductAttributes, navigateDashboard } = Navigations();
  const { userType, setUserType } = useState(0);
  const [countryData, setCountryData] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState(0);

  const [stateData, setStateData] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState(0);

  const [cityData, setCityData] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState(0);

  const { setValidationError, clearAllErrors } = useErrorContext();
  const [isIndian, setisIndian] = useState(null);
  const [values, setValue] = useState({
    isIndian: "",
    isPersonalDetails: "",
    primaryContact: "",
    emailnmobi: "",
    contactnumber: "",
    companyName: "",
    companyInitials: "",
    companyWebsite: "",
    companyGST: "",
    address1: "",
    address2: "",
    country: 101,
    state: 73,
    city: 12545,
    zipCode: "",
  });


  useEffect(() => {
    //  console.log('called useeffectsss');
    if (Array.isArray(users) && users.length > 0) {
      // console.log('useEffect called, users:', users);
      logUserData();
    }
  }, [users]);

  const logUserData = () => {
    // console.log({ users: users });

    if (users?.length > 0) {
      const userTypes = users[0]['UserType'];
      const usertypeArray = typeof userTypes === 'string' ?
        userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];

      const hasOne = usertypeArray.includes(1);
      const hasTwo = usertypeArray.includes(2);
      if (users[0]['IsPersonalDetils'] === 1 && hasOne) {
        // console.log('test 1');
        // navigateDashboard();
        const requiredFields = ["Name", "Initials"];

        const requiredFieldsAreNull = requiredFields.every(
          (key) => users[0].CompanyDetails[key] === null || users[0].CompanyDetails[key] === ""
        );

        if (!requiredFieldsAreNull) {
          navigateDashboard('buyer');
        }
      }
      if (users[0]['IsPersonalDetils'] === 1 && (hasTwo || (hasOne && hasTwo))) {
        // console.log('test 2 success ');
        navigateSellerProductAttributes();
      }
      else {
        setValue({
          ...values,
          emailnmobi: users[0]['EmailAddress'],
          primaryContact: users[0]['Mobile'],
          isIndian: users[0]['IsIndian'],
          isPersonalDetails: users[0]['IsPersonalDetils'],
        });
        if (users[0]['IsIndian'] === 0) {
          setisIndian(false)
          StopLoading(setisLoading);
          getCountries();  // Fetch country if IsIndian is 0
        } else {
          setisIndian(true)
          StopLoading(setisLoading);
          getstates(101); // Fetch states for default case
        }
      }
    }
  };
  const handleGetState = (country) => {
    setSelectedCountryId(country.value)
    getstates(country.value);
  }
  const handleGetCities = (states) => {
    // console.log(states.value);
    setSelectedStateId(parseInt(states.value));
    getCities(states);
  }
  const handleSetCityId = (cities) => {
    setSelectedCityId(cities.value)
  }

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "zipCode") {
      if (value.length < 7) {
        const updatedValue = name === 'companyGST' ? value.toUpperCase() : value;
        setValue(prevValues => ({ ...prevValues, [name]: updatedValue }));
        if (Object.keys(validateAndSetErrors(values)).length === 0) clearAllErrors();
      }
    }
    else {
      const updatedValue = name === 'companyGST' ? value.toUpperCase() : value;
      setValue(prevValues => ({ ...prevValues, [name]: updatedValue }));
      if (Object.keys(validateAndSetErrors(values)).length === 0) clearAllErrors();
    }
  };


  const handleFileChange = ({ target: { files } }) => {
    setValue(prevValues => ({ ...prevValues, file: files[0] }));
  };


  // Reusable function to handle validation and set errors
  const validateAndSetErrors = (values) => {
    const validationErrors = validatePersonalDetailsForm(values);
    Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
    return validationErrors;
  };


  const handleSubmit = e => {
    e.preventDefault();
    const validationErrors = validateAndSetErrors(values);
    // console.log({validationErrors:validationErrors});
    if (Object.keys(validationErrors).length === 0) {
      clearAllErrors();
      const { emailnmobi, primaryContact, companyName, companyInitials, companyWebsite, companyGST, address1, address2, country, state, city, zipCode, file } = values;
      if (!companyName) {
        showToast("Company name is required.", 'error');
      }
      else if (!companyInitials) {
        showToast("Company initials are required.", 'error');
      }
      else if (!address1) {
        showToast("Address 1 is required.", 'error');
      }

      else if (!address2) {
        showToast("Address 2 is required.", 'error');
      }

      else if (!country) {
        showToast("Country is required.", 'error');
      }

      else if (!selectedStateId) {
        showToast("State is required.", 'error');
      }
      else if (!selectedCityId) {
        showToast("City is required.", 'error');
      }

      else if (!zipCode) {
        showToast("Zip Code is required.", 'error');
      }
      else {
        SubmitPersonalDetails(emailnmobi, primaryContact, companyName, companyInitials, companyWebsite, companyGST, address1, address2, country, state, city, zipCode, file); // Assuming checkLogin() is a function to handle actual login logic
      }

    }
  };
  const SubmitPersonalDetails = async (emailnmobi, primaryContact, companyName, companyInitials, companyWebsite, companyGST, address1, address2, country, state, city, zipCode, file) => {
    // console.log('submit usertype is ' + usertype);
    let final_user_type;

    const is_indian = users[0]['is_india'];
    console.log('is_indian' + is_indian );
    const data = { is_indian, emailnmobi, primaryContact, companyName, companyInitials, companyWebsite, companyGST, address1, address2, country, state, city, zipCode, file };
    if (usertype === 'buyer' || usertype === 'Buyer') {
      final_user_type = 1;
      if (!emailnmobi || !companyName || !companyInitials || !address1 || !country || !state || !city || !zipCode) {
        showToast('Please fill all required fields', 'error');
        return;
      }

    } else if (usertype === 'seller' || usertype === 'Seller') {
      final_user_type = 2;
      if (!emailnmobi || !primaryContact || !companyName || !companyInitials || !address1 || !country || !state || !city || !zipCode) {
        showToast('Please fill all required fields', 'error');
        return;
      }
    } else {
      final_user_type = 0;
    }



    var formData = new FormData();
    formData.append("isIndian", final_user_type);
    formData.append("UserTypes", final_user_type);
    formData.append("contactnumber", primaryContact);
    formData.append("companyName", companyName);
    formData.append("companyInitials", companyInitials);
    formData.append("companyWebsite", companyWebsite);
    formData.append("companyGST", companyGST);
    if (file) { formData.append("file", file); }
    formData.append("address1", address1);
    formData.append("address2", address2);
    formData.append("country", country);
    formData.append("states", selectedStateId);
    formData.append("city", selectedCityId);
    formData.append("zipCode", zipCode);
    formData.append("userType", userType);

    // Log the form data contents
    formData.forEach((value, key) => {
      // console.log(key + ": " + value);
    });

    await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddPersonalDetails`, formData, { withCredentials: true, credentials: 'include' })
      .then(handlePersonalDetailsResponse)
      .catch(handlePersonalDetailsError);
  };

  const showToast = (message, type) => {
    const options = {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    };

    if (type === 'success') {
      toast.success(message, options);
    } else {
      toast.error(message, options);
    }
  };
  const clearForm = () => {
    values.fullName = "";
    values.emailAddress = "";
    values.mobileNumber = "";
    values.passWord = "";
  };


  const handlePersonalDetailsResponse = (res) => {
    const result = res.data;
    // console.log({ result: result });
    if (result.success === 1) {
      handleSuccessfulPersonalDetails(result);
    } else {
      showToast(result.message, 'error');
    }

    resetLoadingState();
  };
  const handleSuccessfulPersonalDetails = (result) => {
    const { message, resuserType } = result;
    // console.log(resuserType)
    showToast(message, 'success');
    clearForm();
    if (resuserType === "1,2") {
      navigateSellerProductAttributes();
    }
    else if (resuserType === "1") {
      navigateDashboard('Buyer');
    }
  };
  const handlePersonalDetailsError = (err) => {
    console.error(err);
    showToast(err.response.data.message, 'error');
    resetLoadingState();
  };
  const resetLoadingState = () => {
    setisLoading(false);
  };
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const getCountries = async () => {
    StartLoading(setisLoading);
    try {
      await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getcountries`,).then((res) => {
        StopLoading(setisLoading);
        if (res.data.success === 1) {
          const transformedData = res.data.data.map(country => ({
            label: country.name, // Country name as label
            value: country.id,   // Country ID as value
          }));
          // console.log({ transformedData: transformedData });
          setCountryData(transformedData);
        }
        else {
          showToast(res.data.message, 'error');
        }
      })
        .catch((err) => { });
    } catch (err) {
      StopLoading(setisLoading);
      showToast("Failed to find countries, please try again later ", 'error');
    }
  };
  const getstates = async (country_id) => {
    StartLoading(setisLoading);
    try {
      await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getstates`, { countryid: country_id, }).then((res) => {
        StopLoading(setisLoading);
        if (res.data.success === 1) {
          const transformedData = res.data.data.map(state => ({
            label: state.name, // Country name as label
            value: state.id,   // Country ID as value
          }));
          // console.log({ transformedData: transformedData });
          setStateData(transformedData);
        }
        else {
          showToast(res.data.message, 'error');
        }
      })
        .catch((err) => {
          StopLoading(setisLoading);
          showToast(err.data.message, 'error');
        });
    } catch (err) {
      StopLoading(setisLoading);
      showToast("Failed to find States, please try again later ", 'error');
    }
  };
  const getCities = async (stateid) => {
    StartLoading(setisLoading);
    try {
      await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getcities`, { stateid: stateid.value }).then((res) => {
        StopLoading(setisLoading);
        if (res.data.success === 1) {
          const transformedData = res.data.data.map(city => ({
            label: city.name,
            value: city.id,
          }));
          // console.log({ transformedData: transformedData });
          setCityData(transformedData);
        }
        else {
          showToast(res.data.message, 'error');
        }
      })
        .catch((err) => {
          StopLoading(setisLoading);
          showToast("Failed to find cities, please try again later ", 'error');
        });
    } catch (err) {
      StopLoading(setisLoading);
      showToast("Failed to find cities, please try again later ", 'error');
    }
  };
  return {
    users,
    values, isLoading, handleSubmit, handleChange, handleFileChange, countryData, getCities, getstates, selectedCity, selectedCountry, selectedState, handleSetCityId, isIndian, stateData, cityData, handleGetCities, handleGetState
  }
}

export default MidPersonalDetails